import _isEmpty from "lodash/isEmpty";
import { mapState } from "vuex";
import { getUtmTags, getUserProperties } from "@/utils/userTrackingProperties";

export default {
    // mixins: [userPropsMixin],
    computed: {
        ...mapState({
            userData: state => state.User.data
        }),
        userId() {
            return _isEmpty(this.userData)
                ? undefined
                : this.userData.user.user_id;
        }
    },
    methods: {
        $_trackAll(eventName = "", eventProperties = {}) {
            if (!eventName) {
                return;
            }

            const builtEventProperties = this.$_buildEventProperties(eventProperties);

            this.$_segmentTrackEvent(eventName, builtEventProperties);
        },
        $_buildEventProperties(eventProperties) {
            const moduleGroups = {
                hibooks: "audiobooks",
                nonfiction: "insights"
            };

            const module = moduleGroups[this.$route.meta.group];
            const passedProps = {
                utm_tags: getUtmTags(this.$route.query),
                product: module,
                module,
                userId: this.userId,
                ...eventProperties
            };

            const builtEventProperties = getUserProperties(passedProps, {
                ...this.userData
            });

            return builtEventProperties;
        },
        $_segmentTrackEvent(eventName = "", eventProperties = {}) {
            if (!eventName && _isEmpty(eventProperties)) {
                return;
            }

            if (!_isEmpty(analytics)) {
                analytics.track(eventName, eventProperties);
            }
        }
    }
};
